import React from 'react';

const ReviewSection = ({ title, data }) => (
  <div className="review-section">
    <h4>{title}</h4>
    {data.map((item, index) => (
      <div key={index} className="review-row">
        <div className="review-label">{item.label}</div>
        <div className="review-value">{item.value}</div>
      </div>
    ))}
  </div>
);

export default ReviewSection;
